import React from 'react';
import { useTheme } from '../ThemeContext';

/**
 * Компонент хлебных крошек для навигации
 * @param {Object} props - Пропсы компонента
 * @param {Array} props.items - Массив элементов хлебных крошек [{label, path, onClick}]
 * @param {string} props.separator - Разделитель (по умолчанию /)
 */
const Breadcrumbs = ({ items = [], separator = '/' }) => {
  const { currentTheme } = useTheme();

  const getTextClass = (isActive) => {
    if (currentTheme === 'dark') {
      return isActive ? 'text-white' : 'text-gray-400 hover:text-gray-200';
    }
    if (currentTheme === 'grither') {
      return isActive ? 'text-grither-dark' : 'text-grither-secondary hover:text-grither-primary';
    }
    if (currentTheme === 'custom') {
      return isActive ? 'universal-text-primary' : 'universal-text-secondary';
    }
    return isActive ? 'text-gray-900' : 'text-gray-600 hover:text-gray-900';
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <nav className="flex items-center space-x-2 text-sm mb-4" aria-label="Хлебные крошки">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        const isClickable = item.onClick || item.path;

        return (
          <React.Fragment key={index}>
            {isClickable && !isLast ? (
              <button
                onClick={item.onClick}
                className={`${getTextClass(false)} transition-colors font-medium`}
                aria-label={`Перейти к ${item.label}`}
              >
                {item.label}
              </button>
            ) : (
              <span
                className={`${getTextClass(isLast)} ${isLast ? 'font-semibold' : 'font-medium'}`}
                aria-current={isLast ? 'page' : undefined}
              >
                {item.label}
              </span>
            )}
            
            {!isLast && (
              <span className={getTextClass(false)} aria-hidden="true">
                {separator}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
